export const getCurrentExam = state => state.currentExam
export const getCurrentPage = pagination => pagination.currentPage